import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './work.css'

const Work = (props) => {
  return (
    <div className="work-container10">
      <Helmet>
        <title>Product Design Work | Vlad Butucariu</title>
        <meta
          name="description"
          content="Selected product design, UX/UI, systems, brand, and experimental work by senior product designer Vlad Butucariu."
        />
        <meta
          property="og:title"
          content="Product Design Work | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="Case studies in complex product design, mobile UX, design systems, and visual communication."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/work" />
        <meta property="og:url" content="https://vladbutucariu.com/work" />
      </Helmet>
      <div className="work-thq-wrapper-elm">
        <div className="work-thq-video-div-elm1">
          <video
            src="/Video/irreversible-blob-bg-1780402436590.mp4"
            loop
            muted
            autoPlay
            className="work-video1"
          ></video>
          <video
            src="/Video/irreversible-blob-bg-1780402436590.mp4"
            loop
            muted
            autoPlay
            className="work-video2"
          ></video>
          <video
            src="/Video/irreversible-blob-bg-1780402436590.mp4"
            loop
            muted
            autoPlay
            className="work-thq-video-mobile-elm1"
          ></video>
        </div>
        <div className="work-thq-video-div-elm2">
          <video
            src="/Video/irreversible-blob-bg-1780402436590.mp4"
            loop
            muted
            autoPlay
            className="work-video3"
          ></video>
          <video
            src="/Video/irreversible-blob-bg-1780402436590.mp4"
            loop
            muted
            autoPlay
            className="work-thq-video-mobile-elm2"
          ></video>
        </div>
        <TopMenu
          text1="\xA0[ VLAD BUTUCARIU ]"
          text3="Capabilities"
          text31="Work"
        ></TopMenu>
        <header className="work-thq-top-section-elm">
          <div className="work-thq-tags-elm">
            <div id="tag-filters" className="work-container11 tag-filters">
              <div data-tag="all" className="work-container12 tag">
                <span className="work-text10">all</span>
              </div>
              <div data-tag="artwork" className="work-container13 tag">
                <span className="work-text11">artwork</span>
              </div>
              <div data-tag="ui-ux" className="work-container14 tag">
                <span className="work-text12">ui/ux</span>
              </div>
              <div data-tag="branding" className="work-container15 tag">
                <span className="work-text13">branding</span>
              </div>
              <div data-tag="logo" className="work-container16 tag">
                <span className="work-text14">logo</span>
              </div>
              <div data-tag="generative" className="work-container17 tag">
                <span className="work-text15">generative</span>
              </div>
              <div data-tag="vectorial" className="work-container18 tag">
                <span className="work-text16">vectorial</span>
              </div>
              <div data-tag="dex" className="work-container19 tag">
                <span className="work-text17">dex</span>
              </div>
              <div data-tag="marketplace" className="work-container20 tag">
                <span className="work-text18">marketplace</span>
              </div>
              <div data-tag="nft" className="work-container21 tag">
                <span className="work-text19">nft</span>
              </div>
              <div data-tag="mobile" className="work-container22 tag">
                <span className="work-text20">mobile</span>
              </div>
              <div data-tag="dapp" className="work-container23 tag">
                <span className="work-text21">dapp</span>
              </div>
              <div data-tag="wallet" className="work-container24 tag">
                <span className="work-text22">wallet</span>
              </div>
            </div>
          </div>
          <div className="work-thq-stripe-elm"></div>
        </header>
        <div className="filter-sections">
          <section className="work-thq-section-elm2 dapp branding nft marketplace logo fotonsection ui-ux section">
            <div className="work-thq-color-wrapper-elm2">
              <div className="work-container34">
                <div className="work-container35">
                  <img
                    alt=""
                    src="/Images/tickerpurple.200.svg"
                    className="work-image11"
                  />
                  <div className="work-container36">
                    <Link to="/foton-hub" className="work-navlink12">
                      <h3 className="work-text33">
                        <span>
                          FOTON
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>—</span>
                        <span> MARKETPLACE</span>
                      </h3>
                    </Link>
                    <div className="work-container37">
                      <span className="work-text37 tag-label">
                        product design
                      </span>
                      <span className="work-text38 tag-label">
                        digital assets
                      </span>
                      <span className="tag-label work-text39">dapp</span>
                      <span className="work-text40 tag-label">
                        <span className="work-text41">ux/ui</span>
                        <br></br>
                      </span>
                    </div>
                  </div>
                  <span className="work-text43">
                    FOTON brings marketplace, creation, royalty, and
                    collaboration tools into one coherent experience for
                    digital-asset traders and creators. My role covered
                    end-to-end product design.
                  </span>
                  <div className="work-container38">
                    <Link to="/foton-hub">
                      <div className="work-thq-button-elm10">
                        <span className="work-text44">view project</span>
                        <svg viewBox="0 0 1024 1024" className="work-icon10">
                          <path d="M682.667 298.667v323.669l-353.835-353.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l353.835 353.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h426.667c5.803 0 11.307-1.152 16.341-3.243s9.728-5.163 13.824-9.259c3.925-3.925 7.083-8.619 9.259-13.824 2.091-5.035 3.243-10.539 3.243-16.341v-426.667c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667z"></path>
                        </svg>
                      </div>
                    </Link>
                    <div className="work-thq-button-elm11">
                      <span className="work-text45">launching soon</span>
                    </div>
                  </div>
                </div>
                <div className="work-container39">
                  <div className="work-container40">
                    <Link to="/foton-hub" className="work-navlink14">
                      <div className="work-container41">
                        <img
                          alt="FOTON digital assets marketplace interface"
                          src="/Projects/Web/foton%20hub%201.jpg"
                          className="work-image12"
                        />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="work-thq-section-elm3 branding streamsquiggle wallet logo ui-ux section mobile">
            <div className="work-thq-color-wrapper-elm3">
              <div className="work-container42">
                <div className="work-container43">
                  <img
                    alt=""
                    src="/Images/tickerpurple.200.svg"
                    className="work-image13"
                  />
                  <div className="work-container44">
                    <Link to="/radix-stream" className="work-navlink15">
                      <h3 className="work-text46">
                        <span>RADIX STREAM </span>
                        <span>— WALLET</span>
                      </h3>
                    </Link>
                    <div className="work-container45">
                      <span className="work-text49 tag-label">mobile app</span>
                      <span className="work-text50 tag-label">ux/ui</span>
                      <span className="work-text51 tag-label">
                        <span className="work-text52">brand</span>
                        <br></br>
                      </span>
                    </div>
                  </div>
                  <span className="work-text54">
                    Radix Stream is a clear mobile alternative to desktop
                    wallets, spanning onboarding, portfolio tracking,
                    transactions, account management, and the supporting brand.
                  </span>
                  <div className="work-container46">
                    <Link to="/radix-stream">
                      <div className="work-thq-button-elm12">
                        <span className="work-text55">view project</span>
                        <svg viewBox="0 0 1024 1024" className="work-icon12">
                          <path d="M682.667 298.667v323.669l-353.835-353.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l353.835 353.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h426.667c5.803 0 11.307-1.152 16.341-3.243s9.728-5.163 13.824-9.259c3.925-3.925 7.083-8.619 9.259-13.824 2.091-5.035 3.243-10.539 3.243-16.341v-426.667c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667z"></path>
                        </svg>
                      </div>
                    </Link>
                    <div className="work-thq-button-elm13">
                      <span className="work-text56">launched</span>
                    </div>
                  </div>
                </div>
                <div className="work-container47">
                  <Link to="/radix-stream" className="work-navlink17">
                    <div className="work-container48">
                      <img
                        alt="Radix Stream mobile wallet interface"
                        src="/Projects/Web/stream%20wf3.jpg"
                        className="work-image14"
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </section>
          <section className="work-snapframe-section ui-ux section">
            <div className="work-snapframe-card">
              <div className="work-snapframe-copy">
                <div className="work-snapframe-heading">
                  <Link to="/snapframe" className="work-snapframe-link">
                    <h3>SNAPFRAME — WORKSPACE MANAGER</h3>
                  </Link>
                  <div className="work-snapframe-tags">
                    <span className="tag-label">macos app</span>
                    <span className="tag-label">ux/ui</span>
                    <span className="tag-label">ai tools</span>
                  </div>
                </div>
                <p>
                  SnapFrame is a native macOS workspace tool I am designing and
                  building to combine custom window layouts, keyboard-driven
                  navigation, and live context for developer and AI-assisted
                  workflows.
                </p>
              </div>

              <Link to="/snapframe" className="work-snapframe-media">
                <img
                  alt="SnapFrame macOS application icon"
                  src="/Projects/Snapframe/Snapframe%204%20-%20Icon.png"
                />
              </Link>
            </div>
          </section>
          <div className="work-thq-section-elm1 dapp artwork branding section">
            <div className="work-thq-color-wrapper-elm1">
              <div className="work-thq-label-elm1">
                <div className="work-container26">
                  <span className="work-text23">Tickers</span>
                  <span className="work-text24">
                    generative vector art on ledger
                  </span>
                </div>
                <div className="work-container27"></div>
              </div>
              <div className="work-container28">
                <div className="work-container29">
                  <div className="work-container30">
                    <Link to="/rpfs" className="work-navlink10">
                      <h3 className="work-text25">
                        <span>
                          RPFS
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>—</span>
                        <span> DATA STORAGE</span>
                      </h3>
                    </Link>
                    <div className="work-container31">
                      <span className="work-text29">product design</span>
                      <span className="work-text30 tag-label">dapp</span>
                      <span className="work-text31">webpage</span>
                    </div>
                  </div>
                  <span className="work-text32">
                    RPFS makes decentralized storage, file management, and
                    predictable costs easier to understand for creators and
                    technical users. My role covered product flows and
                    interface design.
                  </span>
                </div>
                <div className="work-container32">
                  <Link to="/rpfs" className="work-navlink11">
                    <div className="work-container33">
                      <img
                        alt="RPFS decentralized storage product interface"
                        src="/Projects/Web/rpfs%201.jpg"
                        className="work-image10"
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="work-thq-section-elm5 wallet ui-ux section">
            <div className="work-thq-color-wrapper-elm5">
              <div className="work-thq-label-elm2">
                <div className="work-container56">
                  <span className="work-text68">Tickers</span>
                  <span className="work-text69">
                    generative vector art on ledger
                  </span>
                </div>
                <div className="work-container57"></div>
              </div>
              <div className="work-container58">
                <div className="work-container59">
                  <img
                    alt=""
                    src="/Images/tickerpurple.200.svg"
                    className="work-image17"
                  />
                  <div className="work-container60">
                    <Link to="/radix-wallet-redo" className="work-navlink21">
                      <h3 className="work-text70">
                        <span>RADIX DLT </span>
                        <span>— WALLET</span>
                      </h3>
                    </Link>
                    <div className="work-container61">
                      <span className="tag-label">mobile app</span>
                      <span className="work-text74">ux/ui</span>
                      <span className="work-text75">concept</span>
                    </div>
                  </div>
                  <span className="work-text76">
                    Built from first-hand use and recurring community feedback,
                    this independent redesign proposal focuses on account
                    organization, navigation, NFT browsing, and clearer
                    settings while preserving the brand.
                  </span>
                  <div className="work-container62">
                    <Link to="/radix-wallet-redo">
                      <div className="work-thq-button-elm16">
                        <span className="work-text77">view project</span>
                        <svg viewBox="0 0 1024 1024" className="work-icon16">
                          <path d="M682.667 298.667v323.669l-353.835-353.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l353.835 353.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h426.667c5.803 0 11.307-1.152 16.341-3.243s9.728-5.163 13.824-9.259c3.925-3.925 7.083-8.619 9.259-13.824 2.091-5.035 3.243-10.539 3.243-16.341v-426.667c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667z"></path>
                        </svg>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="work-container63">
                  <Link to="/radix-wallet-redo" className="work-navlink23">
                    <div className="work-container64">
                      <img
                        alt="Radix Wallet redesign proposal"
                        src="/Projects/radix%20wallet%20proposal%20-%20accounts.png"
                        className="work-image18"
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <section className="work-thq-section-elm4 dapp dex logo ui-ux section">
            <div className="work-thq-color-wrapper-elm4">
              <div className="work-container49">
                <div className="work-container50">
                  <img
                    alt=""
                    src="/Images/tickerpurple.200.svg"
                    className="work-image15"
                  />
                  <div className="work-container51">
                    <Link to="/foton" className="work-navlink18">
                      <h3 className="work-text57">FOTON – Brand and Page</h3>
                    </Link>
                    <div className="work-container52">
                      <span className="work-text58 tag-label">
                        communication
                      </span>
                      <span className="work-text59 tag-label">
                        <span className="work-text60">webpage</span>
                        <br></br>
                      </span>
                      <span className="work-text62 tag-label">
                        <span className="work-text63">brand</span>
                        <br></br>
                      </span>
                    </div>
                  </div>
                  <span className="work-text65">
                    FOTON&apos;s identity and landing experience form a
                    consistent visual system for explaining a technically
                    ambitious product with clarity and character.
                  </span>
                  <div className="work-container53">
                    <Link to="/foton">
                      <div className="work-thq-button-elm14">
                        <span className="work-text66">view project</span>
                        <svg viewBox="0 0 1024 1024" className="work-icon14">
                          <path d="M682.667 298.667v323.669l-353.835-353.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l353.835 353.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h426.667c5.803 0 11.307-1.152 16.341-3.243s9.728-5.163 13.824-9.259c3.925-3.925 7.083-8.619 9.259-13.824 2.091-5.035 3.243-10.539 3.243-16.341v-426.667c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667z"></path>
                        </svg>
                      </div>
                    </Link>
                    <div className="work-thq-button-elm15">
                      <span className="work-text67">launched</span>
                    </div>
                  </div>
                </div>
                <div className="work-container54">
                  <Link to="/foton" className="work-navlink20">
                    <div className="work-container55">
                      <img
                        alt="FOTON brand and landing page"
                        src="/Projects/Web/foton%201.jpg"
                        className="work-image16"
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </section>
          <section className="work-thq-section-elm6 branding fotonsection ui-ux section">
            <div className="work-thq-color-wrapper-elm6">
              <div className="work-container65">
                <div className="work-container66">
                  <img
                    alt=""
                    src="/Images/tickerpurple.200.svg"
                    className="work-image19"
                  />
                  <div className="work-container67">
                    <Link to="/radix-dlt" className="work-navlink24">
                      <h3 className="work-text78">
                        <span>RADIX DLT - WEBPAGE</span>
                        <br></br>
                      </h3>
                    </Link>
                    <div className="work-container68">
                      <span className="tag-label work-text81">
                        communication
                      </span>
                      <span className="work-text82 tag-label">concept</span>
                    </div>
                  </div>
                  <span className="work-text83">
                    A selection of web and communication concepts for Radix,
                    exploring how its technical advantages could become
                    clearer, more tangible, and easier to understand.
                  </span>
                  <div className="work-container69">
                    <Link to="/radix-dlt">
                      <div className="work-thq-button-elm17">
                        <span className="work-text84">view project</span>
                        <svg viewBox="0 0 1024 1024" className="work-icon18">
                          <path d="M682.667 298.667v323.669l-353.835-353.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l353.835 353.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h426.667c5.803 0 11.307-1.152 16.341-3.243s9.728-5.163 13.824-9.259c3.925-3.925 7.083-8.619 9.259-13.824 2.091-5.035 3.243-10.539 3.243-16.341v-426.667c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667z"></path>
                        </svg>
                      </div>
                    </Link>
                    <div className="work-thq-button-elm18">
                      <span className="work-text85">selected concepts</span>
                    </div>
                  </div>
                </div>
                <div className="work-container70">
                  <div className="work-container71">
                    <Link to="/radix-dlt" className="work-navlink26">
                      <div className="work-container72">
                        <img
                          alt="Radix homepage design concept"
                          src="/Projects/radix%20homepage%20redo.png"
                          className="work-image20"
                        />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="work-thq-section-elm7 vectorial artwork nft generative section">
            <div className="work-thq-color-wrapper-elm7">
              <div className="work-thq-label-elm3">
                <div className="work-container73">
                  <span className="work-text86">Tickers</span>
                  <span className="work-text87">
                    generative vector art on ledger
                  </span>
                </div>
                <div className="work-container74"></div>
              </div>
              <div className="work-container75">
                <div className="work-container76">
                  <img
                    alt=""
                    src="/Images/tickerpurple.200.svg"
                    className="work-image21"
                  />
                  <div className="work-container77">
                    <Link to="/tickers" className="work-navlink27">
                      <h3 className="work-text88">
                        <span>TICKERS </span>
                        <span>— GENERATIVE NFTs</span>
                      </h3>
                    </Link>
                    <div className="work-container78">
                      <span className="tag-label">digital assets</span>
                      <span className="work-text92">research</span>
                      <span className="work-text93">concept</span>
                    </div>
                  </div>
                  <span className="work-text94">
                    Tickers is a generative design experiment comprising 1,900
                    vector compositions inspired by timekeeping devices,
                    mechanical systems, and early video-game graphics.
                  </span>
                  <div className="work-container79">
                    <Link to="/tickers">
                      <div className="work-thq-button-elm19">
                        <span className="work-text95">browse collection</span>
                        <svg viewBox="0 0 1024 1024" className="work-icon20">
                          <path d="M682.667 298.667v323.669l-353.835-353.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l353.835 353.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h426.667c5.803 0 11.307-1.152 16.341-3.243s9.728-5.163 13.824-9.259c3.925-3.925 7.083-8.619 9.259-13.824 2.091-5.035 3.243-10.539 3.243-16.341v-426.667c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667z"></path>
                        </svg>
                      </div>
                    </Link>
                    <div className="work-thq-button-elm20">
                      <span className="work-text96">1900 works</span>
                    </div>
                  </div>
                </div>
                <div className="work-container80">
                  <Link to="/tickers" className="work-navlink29">
                    <div className="work-container81">
                      <img
                        alt="Tickers generative vector art collection"
                        src="/Projects/Web/tickers%20w1.jpg"
                        className="work-image22"
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer rootClassName="footerroot-class-name1"></Footer>
        <div className="work-thq-scripts-elm">
          <div>
            <div className="work-container83">
              <React.Fragment>
                <React.Fragment>
                  <style
                    dangerouslySetInnerHTML={{
                      __html:
                        '\n  .tag-filters {\n    display: flex;\n  }\n  .tag-filters div {\n    cursor: pointer;\n    \n  }\n  .section {\n    display: block;\n  }\n',
                    }}
                  />

                  <Script>{`
  function filters() {
  const tagButtons = document.querySelectorAll(".tag");
  const sections = document.querySelectorAll(".section");

  tagButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const tag = button.dataset.tag;
      filterSections(tag);
    });
  });

  function filterSections(tag) {
    sections.forEach((section) => {
      if (tag === "all" || section.classList.contains(tag)) {
        section.style.display = "block";
      } else {
        section.style.display = "none";
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  window.navigation.addEventListener("navigate", (event) => {
    filters();
  });
  filters();
});
filters();
`}</Script>
                </React.Fragment>
              </React.Fragment>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Work
